import React from 'react';
import Input from '../../../components/ui/Input';

const BillingForm = ({ billingInfo, onBillingInfoChange }) => {
  const handleChange = (field, value) => {
    onBillingInfoChange({
      ...billingInfo,
      [field]: value
    });
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Billing Information
      </h2>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        Please provide your company and contact details
      </p>

      <div className="space-y-6">
        {/* Company Information */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Company Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Company Name *"
              placeholder="PNG HR Analytics Ltd"
              value={billingInfo?.companyName}
              onChange={(e) => handleChange('companyName', e?.target?.value)}
              required
            />
            <Input
              label="Legal Company Name"
              placeholder="PNG HR Analytics Limited"
              value={billingInfo?.companyLegalName}
              onChange={(e) => handleChange('companyLegalName', e?.target?.value)}
            />
            <Input
              label="Tax ID / ABN / TIN"
              placeholder="123456789"
              value={billingInfo?.taxIdNumber}
              onChange={(e) => handleChange('taxIdNumber', e?.target?.value)}
            />
          </div>
        </div>

        {/* Contact Information */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Contact Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Contact Name *"
              placeholder="John Doe"
              value={billingInfo?.contactName}
              onChange={(e) => handleChange('contactName', e?.target?.value)}
              required
            />
            <Input
              label="Email Address *"
              type="email"
              placeholder="john@company.com"
              value={billingInfo?.contactEmail}
              onChange={(e) => handleChange('contactEmail', e?.target?.value)}
              required
            />
            <Input
              label="Phone Number *"
              type="tel"
              placeholder="+675 123 4567"
              value={billingInfo?.contactPhone}
              onChange={(e) => handleChange('contactPhone', e?.target?.value)}
              required
            />
          </div>
        </div>

        {/* Address Information */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Business Address
          </h3>
          <div className="space-y-4">
            <Input
              label="Street Address *"
              placeholder="123 Main Street"
              value={billingInfo?.address}
              onChange={(e) => handleChange('address', e?.target?.value)}
              required
            />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Input
                label="City *"
                placeholder="Port Moresby"
                value={billingInfo?.city}
                onChange={(e) => handleChange('city', e?.target?.value)}
                required
              />
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                  Province *
                </label>
                <select
                  value={billingInfo?.province}
                  onChange={(e) => handleChange('province', e?.target?.value)}
                  className="flex h-10 w-full rounded-lg border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                  required
                >
                  <option value="">Select Province</option>
                  <option value="National Capital District">National Capital District</option>
                  <option value="Central">Central</option>
                  <option value="Chimbu">Chimbu</option>
                  <option value="Eastern Highlands">Eastern Highlands</option>
                  <option value="East New Britain">East New Britain</option>
                  <option value="East Sepik">East Sepik</option>
                  <option value="Enga">Enga</option>
                  <option value="Gulf">Gulf</option>
                  <option value="Hela">Hela</option>
                  <option value="Jiwaka">Jiwaka</option>
                  <option value="Madang">Madang</option>
                  <option value="Manus">Manus</option>
                  <option value="Milne Bay">Milne Bay</option>
                  <option value="Morobe">Morobe</option>
                  <option value="New Ireland">New Ireland</option>
                  <option value="Northern">Northern</option>
                  <option value="Southern Highlands">Southern Highlands</option>
                  <option value="Western">Western</option>
                  <option value="Western Highlands">Western Highlands</option>
                  <option value="West New Britain">West New Britain</option>
                  <option value="West Sepik">West Sepik</option>
                </select>
              </div>
              <Input
                label="Postal Code"
                placeholder="111"
                value={billingInfo?.postalCode}
                onChange={(e) => handleChange('postalCode', e?.target?.value)}
              />
            </div>
          </div>
        </div>

        {/* Important Notice */}
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <div className="flex items-start">
            <svg className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <div>
              <h4 className="text-sm font-semibold text-blue-900 dark:text-blue-200 mb-1">
                Important Information
              </h4>
              <p className="text-sm text-blue-800 dark:text-blue-300">
                Your login credentials will be sent to the email address provided above. Please ensure it's correct and accessible.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingForm;